import { AvailableFilter } from "../../../types";

export const AVAILABLE_FILTERS: AvailableFilter[] = [
  {
    title: "Fargetone",
    value: "hue-rotate",
    min: 0,
    max: 360,
    defaultValue: 0,
    unit: "deg",
  },
  {
    title: "Gråtoner",
    value: "grayscale",
    min: 0,
    max: 99,
    defaultValue: 0,
    unit: "%",
  },
  {
    title: "Inverter",
    value: "invert",
    defaultValue: 0,
    min: 0,
    max: 100,
    unit: "%",
  },
  {
    title: "Kontrast",
    value: "contrast",
    defaultValue: 100,
    min: 1,
    max: 200,
    unit: "%",
  },
  {
    title: "Lysstyrke",
    value: "brightness",
    defaultValue: 100,
    min: 1,
    max: 200,
    unit: "%",
  },
  {
    title: "Metning",
    value: "saturate",
    defaultValue: 100,
    min: 1,
    max: 200,
    unit: "%",
  },
  {
    title: "Gjennomsiktighet",
    value: "opacity",
    defaultValue: 100,
    min: 1,
    max: 100,
    unit: "%",
  },
  {
    title: "Sepia",
    value: "sepia",
    defaultValue: 0,
    min: 0,
    max: 99,
    unit: "%",
  },
  {
    title: "Uklarhet",
    value: "blur",
    defaultValue: 0,
    min: 0,
    max: 20,
    unit: "px",
  },
];
